// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/places.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { AdminGeocodeService } from "./places_pb";

/**
 * Geocode looks up a place's bounding box and administrative boundary via
 * Nominatim (OpenStreetMap's own geocoder) — no key required.
 *
 * @generated from rpc travplaces.v1.AdminGeocodeService.Geocode
 */
export const geocode = AdminGeocodeService.method.geocode;

/**
 * SearchPlacesToAdd searches the external provider for a place to add by
 * hand, admin-detail shape (rating, website, phone, ...).
 *
 * @generated from rpc travplaces.v1.AdminGeocodeService.SearchPlacesToAdd
 */
export const searchPlacesToAdd = AdminGeocodeService.method.searchPlacesToAdd;
